import { jsx } from "react/jsx-runtime";
import { Analytics } from "../../../Analytics/index.js";
import { LinkList } from "../../../Navigation/LinkList/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { LinkListStyle } from "./styles.js";
function FlyoutLinkList({
  entry,
  locale
}) {
  if (!entry) {
    console.error("FlyoutLinkList error: Invalid entry.");
    return null;
  }
  const maxLinksPerColumn = entry.number_of_links_per_column;
  const { uid, _content_type_uid } = entry.link_list_ref[0];
  return (
    /** TODO: CostcoBox added to not affect styles in footer and header - will need to be revisited */
    /* @__PURE__ */ jsx(CostcoBox, { sx: LinkListStyle, children: /* @__PURE__ */ jsx(
      Analytics,
      {
        analyticData: {
          component: {
            identifier: "topnav",
            type: "nav"
          },
          trackType: "navigation"
        },
        children: /* @__PURE__ */ jsx(
          LinkList,
          {
            contentType: _content_type_uid,
            entryId: uid,
            insideFlyout: true,
            locale,
            maxLinksPerColumn
          }
        )
      }
    ) })
  );
}
export {
  FlyoutLinkList
};
